.dc-accordion-group {
  margin: 24px 0;
}
